// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--bbXVY_Zy"};